<div >
  <canvas #barcanvases style="width: 100% !important;

        height: 200px !important;" ></canvas>
</div>
